module.exports = __webpack_public_path__ + "static/media/chapa-y-pintura.6cb09fd2.png";